// src/pages/ProvidentFundReq.js
import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Form, Dropdown, ButtonGroup } from 'react-bootstrap';
import { GiMoneyStack } from "react-icons/gi";
import './provident-fund-req.css';
import ProvidentLayout from '../../components/ProvidentLayout.jsx';

// Number of rows per page
const defaultRowsPerPage = 10;
const rowsPerPageOptions = [5, 10, 20, 50]; // Options for rows per page

// Dummy data
const mockRequestData = Array.from({ length: 50 }, (_, index) => ({
  id: index + 1,
  amount: `$${Math.floor(Math.random() * 10000) + 1000}`,
  applied: new Date().toLocaleDateString(),
  approved: Math.random() > 0.5 ? 'Yes' : 'No',
  withdrawsAvailable: Math.floor(Math.random() * 10),
}));

const ProvidentFundReq = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPerPage); // State for rows per page
  const [searchQuery, setSearchQuery] = useState(''); // State for search query

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      const filteredData = mockRequestData.filter(item =>
        item.amount.includes(searchQuery) // Filter by search query
      );
      const startIndex = (currentPage - 1) * rowsPerPage;
      const endIndex = startIndex + rowsPerPage;
      setData(filteredData.slice(startIndex, endIndex)); // Use filtered data
      setLoading(false);
    }, 500); // Simulate a 0.5-second delay
  }, [currentPage, rowsPerPage, searchQuery]); // Dependency array includes rowsPerPage and searchQuery

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= Math.ceil(mockRequestData.length / rowsPerPage)) {
      setCurrentPage(pageNumber);
    }
  };

  const pageRange = () => {
    const pages = [];
    const totalPages = Math.ceil(mockRequestData.length / rowsPerPage);
    let startPage = Math.max(currentPage - 1, 1);
    let endPage = Math.min(startPage + 2, totalPages);

    if (endPage - startPage < 2) {
      startPage = Math.max(endPage - 2, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <div className='container-fluid'>
    <ProvidentLayout>
      <h1 className="provident-fund-req-header">
        <GiMoneyStack className="icon-margin" />
        Provident Fund Requests
      </h1>
      <hr />
      <div className="provident-fund-req-container">
        <div className="emp-info-actions">
          <Row>
            <Col xs={12} md={6} className="d-flex align-items-center">
              <Dropdown as={ButtonGroup}>
                <Button variant="primary" style={{ marginLeft: 0.5 }}>Show Entries</Button>
                <Dropdown.Toggle split variant="primary" id="dropdown-split-basic" />
                <Dropdown.Menu>
                  {rowsPerPageOptions.map(num => (
                    <Dropdown.Item key={num} onClick={() => setRowsPerPage(num)}>
                      {num}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </Col>
            <Col xs={12} md={6} className="d-flex justify-content-end">
              <div className="search-container">
                <Form className="d-flex">
                  <Form.Control
                    type="search"
                    placeholder="Search"
                    aria-label="Search"
                    className="emp-info-search"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)} // Set the search query
                  />
                </Form>
              </div>
            </Col>
          </Row>
        </div>
        <div className="table-responsive">
          <table className="table table-striped provident-fund-req-table">
            <thead className="provident-req-table-header">
              <tr>
                <th>SR</th>
                <th>Amount</th>
                <th>Applied</th>
                <th>Approved</th>
                <th>Withdraw's Available</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan="6" className="text-center">Loading...</td></tr>
              ) : (
                data.length ? (
                  data.map(item => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.amount}</td>
                      <td>{item.applied}</td>
                      <td>{item.approved}</td>
                      <td>{item.withdrawsAvailable}</td>
                      <td><Button variant="primary"size='sm'>Action</Button></td>
                    </tr>
                  ))
                ) : (
                  <tr><td colSpan="6" className="text-center">No data Available Now</td></tr>
                )
              )}
            </tbody>
            <tfoot>
              <tr className="provident-req-table-footer">
                <td>Total</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td></td>
              </tr>
            </tfoot>
          </table>
          <div className="containerrrr">
            <Row className="custom-row">
              <Col xs={12} md={9} className="custom-col-left">
                Showing {(currentPage - 1) * rowsPerPage + 1} to {Math.min(currentPage * rowsPerPage, mockRequestData.length)} of {mockRequestData.length} Entries
              </Col>
              <Col xs={12} md={3} className="custom-col-right">
                <nav>
                  <ul className="pagination">
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                      <a
                        href="/#"
                        className="page-link"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageChange(currentPage - 1);
                        }}
                      >
                        Previous
                      </a>
                    </li>
                    {pageRange().map(pageNumber => (
                      <li key={pageNumber} className={`page-item ${currentPage === pageNumber ? 'active' : ''}`}>
                        <a
                          href="/#"
                          className="page-link"
                          onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(pageNumber);
                          }}
                        >
                          {pageNumber}
                        </a>
                      </li>
                    ))}
                    <li className={`page-item ${currentPage === Math.ceil(mockRequestData.length / rowsPerPage) ? 'disabled' : ''}`}>
                      <a
                        href="/#"
                        className="page-link"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageChange(currentPage + 1);
                        }}
                      >
                        Next
                      </a>
                    </li>
                  </ul>
                </nav>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </ProvidentLayout>
    </div>
  );
};

export default ProvidentFundReq;
